module.exports = {
    // Title/Title Text
    login: 'Login',
    allProductCategory: 'All Product Categories',
    productRecommendation: 'Product Recommendations',
    shopRecommendation: 'Shop Recommendations',
    businessPhilosophy: 'Business Philosophy',
    engine: 'Engine',
    transmission: 'Transmission',
    companyIntroduction: 'Company Introduction',
    photoGallery: 'Photo Gallery',
    contactWay: 'Contact Information',
    basicInformation: 'Basic Information',
    specificationParameters: 'Specification Parameters',
    productDescription: 'Product Description',
    detailedInformation: 'Detailed Information',
    enterpriseName: 'Enterprise Name',
    contact: 'Contact Person',
    email: 'Email',
    area: 'Area',
    detailedAddress: 'Detailed Address',

    // Tags/Label Text
    mainCategory: 'Main Category',
    mainVehicleType: 'Main Vehicle Type',
    mainBrand: 'Main Brand',
    name: 'Name',
    unit: 'Unit',
    shopArea: 'Shop Area',
    shopLocation: 'Shop Location',
    filterCondition: 'Filter Condition',
    category: 'Category',
    brand: 'Brand',
    area_label: 'Area',
    productName: 'Product Name',
    drawingNumber: 'Drawing Number',
    originBrand: 'Origin Brand',
    price: 'Price',
    shopName: 'Shop Name',

    // Button Text
    search: 'Search',
    register: 'Register',
    mobilePhoneLogin: 'Mobile Phone Login',
    accountLogin: 'Account Login',
    getVerificationCode: 'Get Verification Code',
    registerAccount: 'Register Now',
    forgotPassword: 'Forgot Password?',
    contactMethod: 'Contact Method',
    cancelCollection: 'Cancel Collection',
    collectShop: 'Collect Shop',
    collected: 'Collected',
    followShop: 'Follow Shop',
    followed: 'Followed',
    addToCart: 'Add to Cart',
    contactMerchant: 'Contact Merchant',
    moreProducts: 'More Products',
    moreShops: 'More Shops',
    searchThisShop: 'Search This Shop',
    searchAllSites: 'Search All Sites',
    confirm: 'Confirm',
    delete: 'Delete',
    cancel: 'Cancel',
    allProducts: 'All Products',
    companyInfo: 'Company Info',
    basicInfo: 'Basic Info',
    viewBrowsingHistory: 'Browsing History',
    productCollection: 'Product Collection',
    followedShops: 'Followed Shops',
    settledStores: 'Settled Stores',
    feedback: 'Feedback',
    officialService: 'Official Service',
    goOfficialWebsite: 'Go to Official Website',
    openShop: 'Open Shop',
    manageMyShop: 'Manage My Shop',
    registerAccount_btn: 'Register Account',
    haveAccount: 'Already Have Account Login',

    // Prompts/Placeholders
    inputPhoneNumber: 'Please Enter Phone Number',
    inputVerificationCode: 'Please Enter Verification Code',
    inputAccount: 'Please Enter Account',
    inputPassword: 'Please Enter Password',
    inputVerificationCodeAgain: 'Please Enter Verification Code',
    pleaseConfirmPassword: 'Please Confirm Password',
    inputRequiredItems: 'Please Enter Required Items',
    pleaseLogin: 'Please Login First',
    notLoggedIn: 'You Are Not Logged In',
    loggedIn: 'Logged In',
    notOpenedMall: 'Mall Not Opened Yet',
    haveOpenedMall: 'You Have Opened A Mall',
    shopProductName: 'Product Name / Drawing Number / Short Code',
    searchQueryContent: 'Please Enter Query Content',
    loginToGetPhone: 'Please Login to Get',
    pleaseFillVerificationCode: 'Please Fill Verification Code',
    loggingIn: 'Logging In',
    loginSuccessRedirecting: 'Login Successful, Redirecting',
    registerSuccessful: 'Registration Successful',
    collectSuccessful: 'Collection Successful',
    cancelSuccessful: 'Cancel Successful',
    addSuccessful: 'Add Successful',
    deleteSuccessful: 'Delete Successful',
    removeFromCart: 'Remove This Item From Cart?',
    cancelDelete: 'Delete Cancelled',
    hint: 'Hint',
    businessConcept: 'Empower Factories, Win-Win for All Parties<br />Hand in Hand, Build the Future Together',
    companyDescription: 'Main business: Sinotruk and Weichai diesel engines and parts, engineering machinery engines and parts, agency of major international brands: German Hangsdt, German Mahle, German Manhummel, American Donaldson domestic cooperation brands: Zhongyuan inner parts, Blibo tensioner, Jiangbin piston, Bohai piston, Weifu turbocharger',
    transmissionDescription: 'Applicable models: Heavy truck series, mining truck series full range transmission assemblies<br/>Professional production of Sinotruk engine transmissions<br/>Transmission OEM matching brand new assembly',
    pleaseLoginAfterGetContact: 'Please Login to View',
    quote: '—— Honda',
    welcomeUse: 'Welcome to Use',
    shopMallName: 'Xingzhe Intelligent Auto Parts Mall',
    shopMallIntro: 'Login to Xingzhe Intelligence, open a new era of auto parts circulation with peers in the auto parts industry!',
    businessPhilosophyText: 'Empower Factories, Win-Win for All Parties<br />Hand in Hand, Build the Future Together',
    account: 'Account',
    password: 'Password',
    phone: 'Phone Number',
    verificationCode: 'Verification Code',
    home: 'Home',
    officialWebsite: 'Official Website',
    manageSystemExperience: 'Manage System Demo',
    loginPrompt: 'Please Login',
    clickToLogout: 'Click to Logout',
    myOrders: 'My Orders',
    websiteService: 'Website Services',
    contactCustomerService: 'Contact Customer Service',
    shoppingCartLabel: 'Shopping Cart',
    confirmLogoutMessage: 'Do you want to log out? (Some features will become unavailable)',
    logoutSuccess: 'Logged out',
    logoutCancelled: 'Cancelled',
    productSearch: 'Product Search',
    shopSearch: 'Shop Search',
    footerCopyright: 'Copyright © 2024 XingZheZhiNeng All Rights Reserved.',
    addWeChatConsultation: 'Add WeChat Consultation',
    saveImage: 'Save Image',
    productsZone: 'Products Zone',
    shopsZone: 'Shops Zone',
    newArrivals: 'New Arrivals',
    clearanceDeals: 'Clearance Deals',
    hotProducts: 'Hot Products',
    drawingNameSearch: 'Drawing Number / Name Search',
    languageChanged: 'Language Changed'
}